import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
type WelcomeScreenProps = {
  onStart: () => void;
};
export function WelcomeScreen({
  onStart
}: WelcomeScreenProps) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onStart();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onStart]);
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -16
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative min-h-screen w-full flex items-center justify-center px-5 sm:px-6 py-12 overflow-hidden" data-id="element-57">
      {/* Soft radial glow */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10" style={{
      background: 'radial-gradient(circle at 50% 35%, rgba(255,255,255,0.08), transparent 55%)'
    }} data-id="element-58" />

      <div className="max-w-3xl text-center relative" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1,
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex justify-center mb-6 sm:mb-8" data-id="element-60">
          <Logo className="w-14 h-14 sm:w-16 sm:h-16" data-id="element-61" />
        </motion.div>

        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] text-neutral-500 mb-3 sm:mb-4" data-id="element-62">
          Magic Patterns · Ambassadors
        </p>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.1] text-white" data-id="element-63">
          Apply to become a Magic Patterns Ambassador
        </h1>
        <p className="mt-5 sm:mt-6 text-sm sm:text-lg md:text-xl text-neutral-400 leading-relaxed max-w-2xl mx-auto" data-id="element-64">
          Help us bring the magic to more product managers, founders, and
          vibecoders. Ambassadors host events, share Magic Patterns with their
          communities, and shape the future of AI-powered design.
        </p>
        <div className="mt-8 sm:mt-10 flex justify-center" data-id="element-65">
          <button type="button" onClick={onStart} className="group inline-flex items-center gap-2 bg-white text-black font-semibold text-base sm:text-lg px-7 sm:px-8 py-3 rounded-md hover:bg-neutral-200 transition-all hover:gap-3" data-id="element-66">
            Start
            <span className="inline-block transition-transform group-hover:translate-x-0.5" data-id="element-67">
              →
            </span>
          </button>
        </div>
      </div>
    </motion.div>;
}